import Vue from 'vue';
import RadioGroup from '~common/components/form/SuiRadio/SuiRadioGroup';
const TICK_CHECK_REMOVED = 1000;

const KEY_EDITOR = '$customeditor';
const KEY_ROW = '$row';

class CellRadioGroup {
  constructor(row, column, value, parentElement, propsData, dataset) {
    this.initData(row, column, dataset);
    const componentClass = Vue.extend(RadioGroup);
    propsData.value = value;
    this.componentInstance = new componentClass({
      propsData,
    })
    this.componentInstance.$mount();
    parentElement.appendChild(this.componentInstance.$el);
    this.bindedFunction = this.updateDataset.bind(this);
    this.componentInstance.$on(this.eventName, this.bindedFunction);
    this.intervalId = setInterval(() => {
      if (this.isRemoved()) {
        clearInterval(this.intervalId);
        this.destroy();
      }
    }, TICK_CHECK_REMOVED);
    parentElement[KEY_EDITOR] = this;
  }

  initData(row, column, dataset = null) {
    this.dataset = dataset;
    this.rowIndex = row.boundindex;
    this.columnName = column;
    this.componentInstance = null;
    this.eventName = 'input';
    this.row = row;
    this.refreshIndex = -1;
  }

  getComponentInstance() {
    return this.componentInstance;
  }

  refreshEditor(boundindex, column, value, parentElement) {
    // parentElement[KEY_ROW].bounddata[column] = value;
    // this.rowIndex = boundindex;
    // console.log(`${boundindex}, ${value}`);
    this.refreshIndex = boundindex;
    this.componentInstance.setValue(value);
  }

  destroy() {
    this.componentInstance.$off(this.eventName, this.bindedFunction);
    this.componentInstance.$destroy();
  }

  updateDataset(value) {
    if(this.isRemoved()) {
      return;
    }
    // console.log(`bound: ${this.row.boundindex}, visible: ${this.row.visibleindex}, value: ${value}`);
    let rowIndex = this.row.boundindex;
    if (this.refreshIndex >= 0) {
      rowIndex = this.refreshIndex;
    }

    if (this.dataset.data[rowIndex] && this.dataset.data[rowIndex][this.columnName] !== value) {
      this.dataset.setData(rowIndex, this.columnName, value);
    }
  }

  isRemoved() {
    let el = this.componentInstance.$el;
    while(el) {
      if (el === document.body) {
        return false;
      }
      el = el.parentElement;
    }
    return true;
  }
}

export default CellRadioGroup;
